import React, { useState } from "react";
import styles from "./Row.module.sass";
import Checkbox from "../../../../components/Checkbox";

import Icon from "../../../../components/Icon";
import Actions from "../../../../components/Actions";

import Control from "./Control";

const Row = ({ item, setSelectedProducts, removeSelectedProduct }) => {
  const [startDate, setStartDate] = useState(new Date());
  const [startTime, setStartTime] = useState(new Date());

  const [visibleModalProduct, setVisibleModalProduct] = useState(false);
  const [visibleModalSchedule, setVisibleModalSchedule] = useState(false);
  const handleQuantityChange = (productId, change) => {
    setSelectedProducts((prevProducts) =>
      prevProducts.map((product) =>
        product.id === productId
          ? {
              ...product,
              barcodeQuantity: Math.max(
                1,
                (product.barcodeQuantity || 1) + change
              ),
            }
          : product
      )
    );
  };
  const actions = [
    {
      title: "Schedule product",
      icon: "calendar",
      action: () => setVisibleModalSchedule(true),
    },
    {
      title: "Edit title & description",
      icon: "edit",
      action: () => console.log("Edit title & description"),
    },
    {
      title: "Delete forever",
      icon: "trash",
      action: () => console.log("Delete forever"),
    },
  ];

  return (
    <>
      <div className={styles.row}>
        <div className={styles.col}>
          <div
            className={styles.item}
            onClick={() => setVisibleModalProduct(true)}
          >
            <div className={styles.preview}>
              <img
                // srcSet={`${item.image2x} 2x`}
                src={item?.image?.src}
                alt="Product"
              />
            </div>
            <div className={styles.details}>
              <div className={styles.product}>{item.title}</div>
              <div className={styles.link}>{item.link}</div>
              <div className={styles.date}>
                <Icon name="clock" size="20" /> {item.date}
              </div>
              {item.price > 0 ? (
                <div className={styles.price}>${item.price}</div>
              ) : (
                <div className={styles.empty}>${item.price}</div>
              )}
            </div>
          </div>
          <Actions
            className={styles.actions}
            classActionsHead={styles.actionsHead}
            items={actions}
          />
        </div>
        <div className={styles.col}>
          <div className={styles.price}>{item.price}</div>
        </div>
        <div className={styles.col}>{item.inventory_quantity}</div>
        <div className={styles.col}>
          {item.date}
          <Control
            removeSelectedProduct={removeSelectedProduct}
            className={styles.control}
            startDate={startDate}
            setStartDate={setStartDate}
            startTime={startTime}
            setStartTime={setStartTime}
            item={item}
          />
        </div>
        <div className={styles.col}>
          <div className={styles.quantityInput}>
            <input
              type="text"
              value={item.barcodeQuantity || 1}
              // onChange={handleChange} // Make input editable
            />
            <div className={styles.controls}>
              <button onClick={() => handleQuantityChange(item.id, 1)}>
                ▲
              </button>
              <button onClick={() => handleQuantityChange(item.id, -1)}>
                ▼
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Row;
